import { Checkbox, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutNumberOfMovesDetail extends Layout {
    checkboxIncludePartialMovements: Checkbox;
    labelAdded: Label;
    labelDividendCarrierCapacity: Label;
    labelDividendTotalShipments: Label;
    labelDivisorCarrierCapacity: Label;
    labelDivisorTotalShipments: Label;
    labelLeftParenCarrierCapacity: Label;
    labelLeftParenTotalShipments: Label;
    labelRightParenCarrierCapacity: Label;
    labelRightParenTotalShipments: Label;
    labelScoreDetailsCarrierCapacity2: Label;
    labelScoreDetailsCarrierCapacity3: Label;
    labelScoreDetailsCarrierCapacity: Label;
    labelScoreDetailsNumMoves1: Label;
    labelScoreDetailsNumMoves2: Label;
    labelScoreDetailsTotalShipments1: Label;
    labelScoreDetailsTotalShipments2: Label;
    labelScoreDetailsTotalShipments3: Label;
    labelSelectAMeasure: Label;
    labelSubtracted: Label;
    labelWeightCarrierCapacity: Label;
    labelWeightTotalShipments: Label;
    panelFormulaCarrierCapacity: Panel;
    panelFormulaTotalShipments: Panel;
    panelNoMeasure: Panel;
    panelScoreDetailsCarrierCapacity: Panel;
    panelScoreDetailsNumMoves: Panel;
    panelScoreDetailsTotalShipments: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxEndOfPeriod: Textbox;
    textboxMeasure: Textbox;
    textboxMinimumRecords: Textbox;
    textboxPoints: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
